export default __webpack_public_path__ + "static/media/Sarasola.bc0e8905.png";